export default {
    inserted(el) {
        multiline(el)
    },
    componentUpdated(el) {
        multiline(el)
    }
}

function multiline(el) {
    const answerEl = el.querySelector('.Answer-label')

    if (el === null) {
        return
    }

    el.classList.remove('Answer-labelWrapper--multiline')

    // create node clone with 1 char to measure height of element with 1 line of text
    const cloneAnswerEl = answerEl.cloneNode()
    cloneAnswerEl.innerHTML = '1'
    cloneAnswerEl.style.visibility = 'hidden'
    el.appendChild(cloneAnswerEl)
    const lineHeight = cloneAnswerEl.offsetHeight
    el.removeChild(cloneAnswerEl)

    if (answerEl.offsetHeight > lineHeight) {
        el.classList.add('Answer-labelWrapper--multiline')
    }
}